import {
  createCommentsByEntity,
  getCommentsByEntity,
} from 'frontcore/utils/communications/comments'

import { COMMENTS_RELATIONSHIPS } from 'frontcore/constants/comments'


const commentsState = {
  actionComments: [],
  gembaWalkKPIComments: [],
}

const commentsGetters = {
  getCommentByActionId: (state) => (actionId) => {
    return state.actionComments.filter(_comment => _comment[COMMENTS_RELATIONSHIPS.action] === actionId)
  },
  getCommentByGembaWalkKPIId: (state) => (kpiId) => {
    return state.gembaWalkKPIComments.filter(_comment => _comment[COMMENTS_RELATIONSHIPS.kpiCard] === kpiId)
  },
}

const commentsMutations = {
  setActionsComments: (state, comments) => {
    state.actionComments = comments
  },
  setGembaWalkKPIComments: (state, comments) => {
    state.gembaWalkKPIComments = comments
  },
}

const commentsActions = {
  fetchCommentsByActionId: ({ commit }, entityId) => {
    return getCommentsByEntity(entityId, COMMENTS_RELATIONSHIPS.action)
      .then(comments => {
        commit('setActionsComments', comments)
        return comments
      })
      .catch(e => {
        commit('setActionsComments', [])
        throw e
      })
  },
  createActionComments: (_, { entityId, commentData }) => {
    return createCommentsByEntity(entityId, commentData, COMMENTS_RELATIONSHIPS.action)
      .then(comment => comment)
  },
  fetchCommentsByGembaWalkKPIId: ({ commit }, entityId) => {
    return getCommentsByEntity(entityId, COMMENTS_RELATIONSHIPS.kpiCard)
      .then(comments => {
        commit('setGembaWalkKPIComments', comments)
        return comments
      })
      .catch(e => {
        commit('setGembaWalkKPIComments', [])
        throw e
      })
  },
  createGembaWalkKPIIdComments: (_, { entityId, commentData }) => {
    return createCommentsByEntity(entityId, commentData, COMMENTS_RELATIONSHIPS.kpiCard)
      .then(comment => comment)
  },
}

export default {
  actions: commentsActions,
  getters: commentsGetters,
  mutations: commentsMutations,
  state: commentsState,
}
